import gql from 'graphql-tag';

export const getCurrentUserId = gql`
  query getCurrentUserId {
    me {
      user {
        _id
      }
    }
  }
`;

